var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createProxyWithOverrides, toUsdMoney, dollarsToCents, toNumber, centsToDollars, } from '@navinc/utils';
import { forwardRef, useRef, useState } from 'react';
import { BaseStringInput } from '../base-string-input/base-string-input.js';
export const toUSDCents = (valueAsCents) => valueAsCents;
export const BaseUSDInput = forwardRef((_a, ref) => {
    var { value: incomingValue, onChange, onBlur } = _a, props = __rest(_a, ["value", "onChange", "onBlur"]);
    const incomingValueRef = useRef(undefined);
    const valueRef = useRef(undefined);
    const internalValueRef = useRef(undefined);
    const [_, triggerRender] = useState({});
    if (incomingValue !== incomingValueRef.current && valueRef.current !== incomingValue) {
        valueRef.current = incomingValue;
        internalValueRef.current = incomingValue === undefined ? undefined : toUsdMoney(centsToDollars(incomingValue));
    }
    incomingValueRef.current = incomingValue;
    return (_jsx(BaseStringInput, Object.assign({ ref: ref, inputMode: "numeric", value: internalValueRef.current, onChange: (e) => {
            const outValue = e.target.value;
            const displayValue = toUsdMoney(outValue);
            const updatedEvent = e;
            // when no content is in the value, emit value as undefined
            if (outValue === '' || outValue === '$') {
                internalValueRef.current = '';
                valueRef.current = undefined;
                updatedEvent.target = createProxyWithOverrides(updatedEvent.target, { value: undefined });
                triggerRender({}); // to update the input value
                onChange === null || onChange === void 0 ? void 0 : onChange(updatedEvent);
                return;
            }
            // when the displayValue doesn't change, it indicates an invalid input. Revert and stop
            if (displayValue === internalValueRef.current && displayValue !== '-') {
                // prevent invalid input
                e.target.value = internalValueRef.current;
                return;
            }
            internalValueRef.current = outValue === '-' ? outValue : displayValue;
            triggerRender({}); // to update the input value
            const numberValue = displayValue === '' ? undefined : dollarsToCents(toNumber(displayValue) || 0);
            valueRef.current = numberValue;
            updatedEvent.target = createProxyWithOverrides(updatedEvent.target, { value: numberValue });
            onChange === null || onChange === void 0 ? void 0 : onChange(updatedEvent);
        }, onBlur: (e) => {
            // in the case of an incomplete value (like "-"), fix to formatted value on blur
            internalValueRef.current =
                valueRef.current === undefined ? undefined : toUsdMoney(centsToDollars(valueRef.current));
            triggerRender({}); // to update the input value
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        } }, props)));
});
//# sourceMappingURL=base-usd-input.js.map